<div class="pro-widget">
  <div class="pro-widget__title pro-widget__title--peer-groups">
    <div class="pro-widget__title-text">Create Peer Group</div>
    <a routerLink="/peer-comparison/groups/manage" class="all-peer-groups">View Peer Groups</a>
  </div>
  <div class="peer-groups" [ngClass]="{ 'upgrade-lock': basicPlan }">
    <div class="cpg-selector" [ngClass]="{ 'cpg-selector--selected': selection != PeerGroupType.None }">
      <div class="cpg-selector__option" [ngClass]="{ 'cpg-selector__option--selected': selection == PeerGroupType.Similar, 'cpg-selector__option--disabled': selection != PeerGroupType.Similar && selection != PeerGroupType.None }">
        <div class="cpg-selector__title" (click)="switchType(PeerGroupType.Similar)">Similar Credit Unions</div>
        <div class="cpg-selector__desc expand" [ngClass]="{ 'expand--expanded': similarMore }">
          <p>Use an automated search to identify a peer group of credit unions with similar balance sheet characteristics at a point in time.  You can use this to create a Benchmark Peer Group based on past metrics and track your recent performance against this group.</p>
          <div class="expand__more">
            <p>In addition to selecting the date, you have the option to limit the peer group to credit unions within your state. The search algorithm will find credit unions that are similar to yours in terms of loan balances, deposit balances, and overall assets.</p>
            <p>The automated search aims to keep the group size small and apply the inclusion criteria consistently.  For example, if the search results contain one credit union whose balances and assets are both within 15% of yours, they must contain all credit unions whose balances and assets are within 15% of yours.</p>
          </div>
          <a (click)="similarMore = true" class="expand__link expand__link--more">Learn More <svg class="icon expand__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M169.4 278.6C175.6 284.9 183.8 288 192 288s16.38-3.125 22.62-9.375l160-160c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0L192 210.8L54.63 73.38c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L169.4 278.6zM329.4 265.4L192 402.8L54.63 265.4c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25l160 160C175.6 476.9 183.8 480 192 480s16.38-3.125 22.62-9.375l160-160c12.5-12.5 12.5-32.75 0-45.25S341.9 252.9 329.4 265.4z" /></svg></a>
          <a (click)="similarMore = false" class="expand__link expand__link--less">Show Less <svg class="icon expand__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M54.63 246.6L192 109.3l137.4 137.4C335.6 252.9 343.8 256 352 256s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25l-160-160c-12.5-12.5-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25S42.13 259.1 54.63 246.6zM214.6 233.4c-12.5-12.5-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25s32.75 12.5 45.25 0L192 301.3l137.4 137.4C335.6 444.9 343.8 448 352 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L214.6 233.4z" /></svg></a>
        </div>
      </div>
      <div class="cpg-selector__option" [ngClass]="{ 'cpg-selector__option--selected': selection == PeerGroupType.Targeted, 'cpg-selector__option--disabled': selection != PeerGroupType.Targeted && selection != PeerGroupType.None }" (click)="switchType(PeerGroupType.Targeted)">
        <div class="cpg-selector__title">Targeted Credit Unions</div>
        <div class="cpg-selector__desc">Create a peer group with targeted characteristics such as asset size, loan portfolio concentration, or profitability.  This is a good way to identify credit unions that are performing well in a particular line of business or to create an Aspirational Peer Group of credit unions to guide your business plan development.</div>
      </div>
      <div class="cpg-selector__option" [ngClass]="{ 'cpg-selector__option--selected': selection == PeerGroupType.Distinct, 'cpg-selector__option--disabled': selection != PeerGroupType.Distinct && selection != PeerGroupType.None }" (click)="switchType(PeerGroupType.Distinct)">
        <div class="cpg-selector__title">Distinct Credit Unions</div>
        <div class="cpg-selector__desc">Search by name to select the credit unions for the peer group.</div>
      </div>
    </div>
    <div class="cpg-option" [ngClass]="{ 'cpg-option--similar': selection == PeerGroupType.Similar, 'cpg-option--targeted': selection == PeerGroupType.Targeted, 'cpg-option--distinct': selection == PeerGroupType.Distinct}">
      <div class="cpg-option" [ngClass]="{ 'cpg-option--similar': selection == PeerGroupType.Similar, 'cpg-option--targeted': selection == PeerGroupType.Targeted, 'cpg-option--distinct': selection == PeerGroupType.Distinct}">
        @if (selection == PeerGroupType.Similar) {
        <div>
          <div class="cpg-row cpg-row--date">
            <div class="cpg-row__title">Select Reporting Date</div>
            <app-date-selector id="tour-group-create-date" [periods]="41" [globalState]="false" (dateChange)="onDateChange($event)"></app-date-selector>
          </div>
          <div class="cpg-row cpg-row-profile">
            <ng-select id="tour-group-create-tom"
                       [(ngModel)]="selectedTypesOfMembership"
                       (change)="getInstitutions()"
                       [multiple]="true"
                       [closeOnSelect]="false"
                       [searchable]="false"
                       placeholder="Select Types of Membership">
              @for (tom of typesOfMembership; track tom.tomCode) {
              <ng-option [value]="tom.tomCode">{{ tom.tomCodeAlpha }} - {{ tom.tomCodeDesc }}</ng-option>
              }
            </ng-select>
            <ng-select id="tour-group-create-state"
                       [(ngModel)]="selectedStates"
                       (change)="onStateChange()"
                       [multiple]="true"
                       [closeOnSelect]="false"
                       [searchable]="false"
                       placeholder="Select States">
              @for (state of states; track state.abbreviation) {
              <ng-option [value]="state.abbreviation">{{ state.name }}</ng-option>
              }
            </ng-select>
          </div>
        </div>
        }
      </div>
      @if (selection == PeerGroupType.Targeted) {
      <div>
        <div class="cpg-row cpg-row--date">
          <div class="cpg-row__title">Select Reporting Date</div>
          <app-date-selector id="tour-group-create-date" [periods]="41" [globalState]="false" (dateChange)="onDateChange($event)"></app-date-selector>
        </div>
        <div id="tour-group-create-asset-range" class="cpg-row cpg-row--size">
          <div class="cpg-row__title">Asset Range</div>
          <label class="check-control">
            <input type="checkbox" [(ngModel)]="assetRangeEnabled" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
          </label>
          <input type="text" class="range-input" [(ngModel)]="assetRangeMin" (blur)="onRangeChange()" [mask]="assetRangeMask" [disabled]="!assetRangeEnabled" placeholder="Min" />
          <span class="cpg-row__title">TO</span>
          <input type="text" class="range-input" [(ngModel)]="assetRangeMax" (blur)="onRangeChange()" [mask]="assetRangeMask" [disabled]="!assetRangeEnabled" placeholder="Max" />
        </div>
        <div id="tour-group-create-lns-to-dep" class="cpg-row cpg-row--size">
          <div class="cpg-row__title">Loans to Deposits</div>
          <label class="check-control">
            <input type="checkbox" [(ngModel)]="lnsToDepRangeEnabled" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
          </label>
          <input type="text" class="range-input" [(ngModel)]="lnsToDepRangeMin" (blur)="onRangeChange()" [disabled]="!lnsToDepRangeEnabled" placeholder="Min" />
          <span class="cpg-row__title">TO</span>
          <input type="text" class="range-input" [(ngModel)]="lnsToDepRangeMax" (blur)="onRangeChange()" [disabled]="!lnsToDepRangeEnabled" placeholder="Max" />
        </div>
        <div id="tour-group-create-asset-growth" class="cpg-row cpg-row--size">
          <div class="cpg-row__title">Asset Growth</div>
          <label class="check-control">
            <input type="checkbox" [(ngModel)]="assetGrowthRangeEnabled" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
          </label>
          <input type="text" class="range-input" [(ngModel)]="assetGrowthRangeMin" (blur)="onRangeChange()" [disabled]="!assetGrowthRangeEnabled" placeholder="Min" />
          <span class="cpg-row__title">TO</span>
          <input type="text" class="range-input" [(ngModel)]="assetGrowthRangeMax" (blur)="onRangeChange()" [disabled]="!assetGrowthRangeEnabled" placeholder="Max" />
        </div>
        <div class="cpg-checks-filters">
          <table id="tour-group-create-profile" class="ft-table cpg-table-checks" [ngClass]="{ 'ft-table--open': institutionProfileExpanded }">
            <caption class="cpg-table-checks__title" colspan="100" (click)="institutionProfileExpanded = !institutionProfileExpanded">
              <span>Institution Profile</span>
              <svg class="icon bal__row-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"></path></svg>
            </caption>
            <tbody>
              <tr>
                <td>
                  <ng-select id="tour-group-create-tom"
                             [(ngModel)]="selectedTypesOfMembership"
                             (change)="getInstitutions()"
                             [multiple]="true"
                             [closeOnSelect]="false"
                             [searchable]="false"
                             placeholder="Select Types of Membership">
                    @for (tom of typesOfMembership; track tom.tomCode) {
                    <ng-option [value]="tom.tomCode">{{ tom.tomCodeAlpha }} - {{ tom.tomCodeDesc }}</ng-option>
                    }
                  </ng-select>
                </td>
                <td>
                  <ng-select id="tour-group-create-state"
                             [(ngModel)]="selectedStates"
                             (change)="onStateChange()"
                             [multiple]="true"
                             [closeOnSelect]="false"
                             [searchable]="false"
                             placeholder="Select States">
                    @for (state of states; track state.abbreviation) {
                    <ng-option [value]="state.abbreviation">{{ state.name }}</ng-option>
                    }
                  </ng-select>
                </td>
              </tr>
            </tbody>
          </table>
          <table id="tour-group-create-concentrations" class="ft-table cpg-table-checks" [ngClass]="{ 'ft-table--open': loanConcentrationExpanded }">
            <caption class="cpg-table-checks__title" colspan="100" (click)="loanConcentrationExpanded = !loanConcentrationExpanded">
              <span>
                Loan Concentration
                <span class="tooltip">
                  To be included in the peer group, credit unions must have a loan concentration of at least 25% within
                  each of the selected areas.
                </span>
              </span>
              <svg class="icon bal__row-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"></path></svg>
            </caption>
            <tbody>
              <tr>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="resiInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Residential</span>
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="newAutoInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Auto (New)</span>
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="usedAutoInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Auto (Used)</span>
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="creInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Commercial Real Estate</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
          <table id="tour-group-create-services" class="ft-table cpg-table-checks" [ngClass]="{ 'ft-table--open': servicesOfferedExpanded }">
            <caption class="cpg-table-checks__title" colspan="100" (click)="servicesOfferedExpanded = !servicesOfferedExpanded">
              <span>
                Services Offered
                <span class="tooltip">
                  Services offered are inferred from call report data.
                </span>
              </span>
              <svg class="icon bal__row-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"></path></svg>
            </caption>
            <tbody>
              <tr>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="firstTimeHomebuyer" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">First Time Homebuyer Program</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="creditBuilderRepairMain" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Credit Builder, Management and Repair Services</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="mortgageSeller" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Approved Mortgage Seller</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="leaseInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Lease financing</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
              </tr>
              <tr>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="studentInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Student Loans</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="commlInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Commercial</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="ccInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Credit Card</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
                <td>
                  <label class="check-control">
                    <input type="checkbox" [(ngModel)]="lowIncInd" [ngModelOptions]="{ standalone: true }" (change)="getInstitutions()" value="true" />
                    <span class="check-control__text">Low Income Area Provider</span>
                  </label>
                  <span class="tooltip">Tooltip</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table id="tour-group-create-metrics" class="ft-table cpg-table-filters" [ngClass]="{ 'ft-table--open': performanceMetricsExpanded }">
            <caption class="cpg-table-checks__title" (click)="performanceMetricsExpanded = !performanceMetricsExpanded">
              <span>
                Performance Metrics
              </span>
              <svg class="icon bal__row-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 384c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L192 306.8l137.4-137.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-160 160C208.4 380.9 200.2 384 192 384z"></path></svg>
            </caption>
            <tbody>
              <tr style="font-weight: bold; background-color: white; border: 2px solid var(--color-grey); line-height: 1.5;">
                <td>Metric</td>
                <td>Credit Union Value</td>
                <td>N/A</td>
                <td>Better</td>
                <td>Range</td>
                <td>Min</td>
                <td>Max</td>
              </tr>
              <tr>
                <td>Return On Equity</td>
                <td>{{ pctDisplay(clientProfile()?.roeQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="roeFilter" [value]="0" [(ngModel)]="roeFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="roeFilter" [value]="1" [(ngModel)]="roeFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="roeFilter" [value]="-1" [(ngModel)]="roeFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="roeMin" [(ngModel)]="roeMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="roeFilter != -1" /></td>
                <td><input type="text" name="roeMax" [(ngModel)]="roeMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="roeFilter != -1" /></td>
              </tr>
              <tr>
                <td>Return On Assets</td>
                <td>{{ pctDisplay(clientProfile()?.roaQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="roaFilter" [value]="0" [(ngModel)]="roaFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="roaFilter" [value]="1" [(ngModel)]="roaFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="roaFilter" [value]="-1" [(ngModel)]="roaFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="roaMin" [(ngModel)]="roaMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="roaFilter != -1" /></td>
                <td><input type="text" name="roaMax" [(ngModel)]="roaMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="roaFilter != -1" /></td>
              </tr>
              <tr>
                <td>Net Interest Margin</td>
                <td>{{ pctDisplay(clientProfile()?.netIntMarginQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="netIntMarginFilter" [value]="0" [(ngModel)]="netIntMarginFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="netIntMarginFilter" [value]="1" [(ngModel)]="netIntMarginFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="netIntMarginFilter" [value]="-1" [(ngModel)]="netIntMarginFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="netIntMarginMin" [(ngModel)]="netIntMarginMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="netIntMarginFilter != -1" /></td>
                <td><input type="text" name="netIntMarginMax" [(ngModel)]="netIntMarginMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="netIntMarginFilter != -1" /></td>
              </tr>
              <tr>
                <td>Net Overhead</td>
                <td>{{ pctDisplay(clientProfile()?.netOverhead) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="netOverheadFilter" [value]="0" [(ngModel)]="netOverheadFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="netOverheadFilter" [value]="1" [(ngModel)]="netOverheadFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="netOverheadFilter" [value]="-1" [(ngModel)]="netOverheadFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="netOverheadMin" [(ngModel)]="netOverheadMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="netOverheadFilter != -1" /></td>
                <td><input type="text" name="netOverheadMax" [(ngModel)]="netOverheadMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="netOverheadFilter != -1" /></td>
              </tr>
              <tr>
                <td>Yield on Earning Assets</td>
                <td>{{ pctDisplay(clientProfile()?.yeaQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="yeaFilter" [value]="0" [(ngModel)]="yeaFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="yeaFilter" [value]="1" [(ngModel)]="yeaFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="yeaFilter" [value]="-1" [(ngModel)]="yeaFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="yeaMin" [(ngModel)]="yeaMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="yeaFilter != -1" /></td>
                <td><input type="text" name="yeaMax" [(ngModel)]="yeaMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="yeaFilter != -1" /></td>
              </tr>
              <tr>
                <td>Loan Yield</td>
                <td>{{ pctDisplay(clientProfile()?.yldOnLnsQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="yldOnLnsFilter" [value]="0" [(ngModel)]="yldOnLnsFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="yldOnLnsFilter" [value]="1" [(ngModel)]="yldOnLnsFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="yldOnLnsFilter" [value]="-1" [(ngModel)]="yldOnLnsFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="yldOnLnsMin" [(ngModel)]="yldOnLnsMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="yldOnLnsFilter != -1" /></td>
                <td><input type="text" name="yldOnLnsMax" [(ngModel)]="yldOnLnsMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="yldOnLnsFilter != -1" /></td>
              </tr>
              <tr>
                <td>Cost of Funds</td>
                <td>{{ pctDisplay(clientProfile()?.cofQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="cofFilter" [value]="0" [(ngModel)]="cofFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="cofFilter" [value]="1" [(ngModel)]="cofFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="cofFilter" [value]="-1" [(ngModel)]="cofFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="cofMin" [(ngModel)]="cofMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="cofFilter != -1" /></td>
                <td><input type="text" name="cofMax" [(ngModel)]="cofMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="cofFilter != -1" /></td>
              </tr>
              <tr>
                <td>Deposit Cost</td>
                <td>{{ pctDisplay(clientProfile()?.cstDepQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="cstDepFilter" [value]="0" [(ngModel)]="cstDepFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="cstDepFilter" [value]="1" [(ngModel)]="cstDepFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="cstDepFilter" [value]="-1" [(ngModel)]="cstDepFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="cstDepMin" [(ngModel)]="cstDepMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="cstDepFilter != -1" /></td>
                <td><input type="text" name="cstDepMax" [(ngModel)]="cstDepMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="cstDepFilter != -1" /></td>
              </tr>
              <tr>
                <td>Texas Ratio</td>
                <td>{{ pctDisplay(clientProfile()?.texasRatioQe) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="TexasRatioFilter" [value]="0" [(ngModel)]="texasRatioFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="TexasRatioFilter" [value]="1" [(ngModel)]="texasRatioFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="TexasRatioFilter" [value]="-1" [(ngModel)]="texasRatioFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="texasRatioMin" [(ngModel)]="texasRatioMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="texasRatioFilter != -1" /></td>
                <td><input type="text" name="texasRatioMax" [(ngModel)]="texasRatioMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="texasRatioFilter != -1" /></td>
              </tr>
              <tr>
                <td>Member Growth</td>
                <td>{{ pctDisplay(clientProfile()?.memberGrowth) }}</td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="MemberGrowthFilter" [value]="0" [(ngModel)]="memberGrowthFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="MemberGrowthFilter" [value]="1" [(ngModel)]="memberGrowthFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td>
                  <label class="check-control">
                    <input type="radio" name="MemberGrowthFilter" [value]="-1" [(ngModel)]="memberGrowthFilter" (change)="getInstitutions()" />
                  </label>
                </td>
                <td><input type="text" name="memberGrowthMin" [(ngModel)]="memberGrowthMin" class="range-input-performance" placeholder="Min" (blur)="onRangeChange()" [disabled]="memberGrowthFilter != -1" /></td>
                <td><input type="text" name="memberGrowthMax" [(ngModel)]="memberGrowthMax" class="range-input-performance" placeholder="Max" (blur)="onRangeChange()" [disabled]="memberGrowthFilter != -1" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      }
      @if (selection != PeerGroupType.None) {
      <div class="peer--open cpg-table peer">
        @if (selection == PeerGroupType.Distinct) {
        <div class="peer__add">
          <span class="peer__add-icon"><svg class="icon peer__add-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 368C269.3 368 280 357.3 280 344V280H344C357.3 280 368 269.3 368 256C368 242.7 357.3 232 344 232H280V168C280 154.7 269.3 144 256 144C242.7 144 232 154.7 232 168V232H168C154.7 232 144 242.7 144 256C144 269.3 154.7 280 168 280H232V344C232 357.3 242.7 368 256 368z" /></svg></span>
          <app-institution-autocomplete #institutionAutocomplete
                                        placeholder="Start typing to add a new credit union to this group"
                                        class="peer__add-input"
                                        [onlyActive]="true"
                                        [institutionType]="institution().institutionType"
                                        [excludedIids]="distinctIids"
                                        (selectInstitutionEvent)="onSelectInstitution($event)">
          </app-institution-autocomplete>
        </div>
        }
        <div class="peer__table">
          <table>
            <thead id="tour-group-create-list">
              <tr>
                <th class="peer-table__title col-sort" [ngClass]="getSortClass('name')" (click)="onSort('name')">Credit Unions Selected</th>
                <th class="col-sort" [ngClass]="getSortClass('creditUnionType')" (click)="onSort('creditUnionType')">Type</th>
                <th class="col-sort" [ngClass]="getSortClass('totalAssetsQe')" (click)="onSort('totalAssetsQe')">Assets</th>
                <th class="col-sort" [ngClass]="getSortClass('annualAssetGrowth')" (click)="onSort('annualAssetGrowth')">Asset Growth (3yr Avg)</th>
                <th class="col-sort" [ngClass]="getSortClass('roeQe')" (click)="onSort('roeQe')">Return on Equity</th>
                <th class="col-sort" [ngClass]="getSortClass('roaQe')" (click)="onSort('roaQe')">Return On Assets</th>
                <th class="col-sort" [ngClass]="getSortClass('netIntMarginQe')" (click)="onSort('netIntMarginQe')">Net Interest Margin</th>
                <th class="col-sort" [ngClass]="getSortClass('texasRatioQe')" (click)="onSort('texasRatioQe')">Texas Ratio</th>
                <th class="col-sort" [ngClass]="getSortClass('nonIntIncToTotalAssetsQe')" (click)="onSort('nonIntIncToTotalAssetsQe')">Non Interest Income to Total Assets</th>
              </tr>
            </thead>
            <tbody>
              <tr class="peer-table-user-bank">
                <td>{{ clientProfile()?.label }}</td>
                <td>{{ clientProfile()?.creditUnionType }}</td>
                <td>{{ usdDisplay(clientProfile()?.totalAssetsQe) }}</td>
                <td>{{ pctDisplay(clientProfile()?.annualAssetGrowth) }}</td>
                <td>{{ pctDisplay(clientProfile()?.roeQe) }}</td>
                <td>{{ pctDisplay(clientProfile()?.roaQe) }}</td>
                <td>{{ pctDisplay(clientProfile()?.netIntMarginQe) }}</td>
                <td>{{ pctDisplay(clientProfile()?.texasRatioQe) }}</td>
                <td>{{ pctDisplay(clientProfile()?.nonIntIncToTotalAssetsQe) }}</td>
              </tr>
              @for (institution of institutions | paginate: { itemsPerPage: 25, currentPage: page }; track institution.iid) {
              <tr [ngClass]="{ 'bank-removed': institution.isRemoved, 'bank-added': institution.isAdded }">
                <td>
                  @if (selection == PeerGroupType.Similar) {
                  <div class="peer__bank-name">
                    @if (institution.websiteAddress && institution.websiteAddress.length > 0) {
                    <a href="{{ fixUrl(institution.websiteAddress) }}" target="_blank">{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</a>
                    } @else {
                    <span>{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</span>
                    }
                  </div>
                  } @else {
                  <div class="peer__bank-name">
                    @if (institution.websiteAddress && institution.websiteAddress.length > 0) {
                    <a href="{{ fixUrl(institution.websiteAddress) }}" target="_blank">{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</a>
                    } @else {
                    <span>{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</span>
                    }
                    <span (click)="removeInstitution(institution.iid)" class="peer__bank-name-remove">Remove</span>
                  </div>
                  }
                </td>
                <td>{{ institution.creditUnionType }}</td>
                <td>{{ usdDisplay(institution.totalAssetsQe) }}</td>
                <td>{{ pctDisplay(institution.annualAssetGrowth) }}</td>
                <td>{{ pctDisplay(institution.roeQe) }}</td>
                <td>{{ pctDisplay(institution.roaQe) }}</td>
                <td>{{ pctDisplay(institution.netIntMarginQe) }}</td>
                <td>{{ pctDisplay(institution.texasRatioQe) }}</td>
                <td>{{ pctDisplay(institution.nonIntIncToTotalAssetsQe) }}</td>
              </tr>
              }
            </tbody>
          </table>
          <div class="pagination">
            <pagination-controls (pageChange)="page = $event"></pagination-controls>
          </div>
        </div>
        @if (loading) {
        <div class="loading-update">
          <div class="loading-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        }
      </div>
      }
    </div>
    @if (basicPlan) {
    <div class="upgrade-cta">
      <div class="upgrade-cta__inner">
        <div class="upgrade-cta__title">Get This Feature!</div>
        <div class="upgrade-cta__text">Upgrade your plan to create customized peer groups and perform targeted analyses of your competitors.</div>
        <a class="upgrade-cta__btn button" routerLink="/upgrade-pricing">Upgrade Plan</a>
      </div>
    </div>
    }
  </div>
</div>

<div class="peer-actions" [ngClass]="{ 'peer-actions--open': selection != PeerGroupType.None }">
  <div class="peer-actions__summary">
    <span class="peer-actions__count peer-actions__count--added">{{ institutions.length }}</span> Credit Unions Selected
  </div>
  <div id="tour-group-create-actions">
    <button (click)="discardChanges()" class="peer-actions__option peer-actions__option--discard" type="button">Discard Changes</button>
    <button (click)="createGroup()" class="peer-actions__option peer-actions__option--save" type="button" [disabled]="institutions.length == 0 ||  institutions.length > 100">Create Group</button>
  </div>
  @if (institutions.length > 100) {
  <span class="peer-actions__warning">
    Custom Peer Groups are limited to 100 credit unions.  LakeHouse Anayltics recommends Peer Groups of 25 or fewer.
  </span>
  }
</div>

<div #dialog></div>
